import React from 'react';

import {useTranslation} from 'react-i18next';
import styled from 'styled-components';

import {ReactComponent as CrossIcon} from 'assets/svg/cross.svg';
import {breakpoint} from 'theme';

import {Icon} from '../Icon';
import {IconButton} from '../IconButton';

export const Button = ({className, onClick}: {className?: string; onClick?: () => void}) => {
    const {t} = useTranslation();
    return (
        <IconButton
            label={t('components.sidebar.Close')}
            icon={<Icon source={CrossIcon} />}
            className={className}
            onClick={onClick}
            type="button"
        />
    );
};

export const DrawerCloseButton = styled(Button)`
    svg {
        width: 18px;
        height: 18px;
    }

    @media (min-width: ${breakpoint.tablet}) {
        svg {
            width: 14px;
            height: 14px;
        }
    }
`;
